import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "row h-100" }
const _hoisted_8 = { class: "col h-100" }
const _hoisted_9 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_10 = { class: "form-check" }
const _hoisted_11 = { class: "col-sm-6" }
const _hoisted_12 = { class: "mb-3" }

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useCondimentStore } from '@/store/management/condimentsStore';
import type { Condiment } from '@/store/management/condimentsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'condimentsBasic',
  setup(__props) {

const condimentsAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/condimentsPage/condimentsAltLangModal.vue'))

const condimentStore = useCondimentStore()

onMounted(() => {
    if (tempActiveCondiment.value?.id) {
        compState.id = tempActiveCondiment.value.id
        compState.name = tempActiveCondiment.value.name
        compState.price = tempActiveCondiment.value.price
        compState.preset = tempActiveCondiment.value.preset
        compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
    }
})

const compState = reactive({
    id: '',
    name: '',
    price: 0,
    preset: false,
    altLangText: ''
})

const activeCondiment = computed(() => {
    return condimentStore.getActiveCondiment
})

const tempActiveCondiment = computed(() => {
    return condimentStore.getTempActiveCondiment
})

const activeCondimentId = computed(() => {
    return condimentStore.getActiveCondimentId
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
}

watch(activeCondimentId, (newVal) => {
    if (newVal) {
        const productGroup = activeCondiment.value
        compState.id = productGroup.id
        compState.name = productGroup.name
        compState.price = productGroup.price
        compState.preset = productGroup.preset
        compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
    }
}, { immediate: true })

watch(compState, (newVal) => {
    condimentStore.setTempActiveCondiment({
        ...tempActiveCondiment.value,
        id: newVal.id,
        name: newVal.name,
        price: newVal.price,
        preset: newVal.preset,
    } as Condiment)
}, { deep: true });

const priceIncrement = () => {
    compState.price++
}

const priceDecrement = () => {
    if (compState.price > 0) {
        compState.price--
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Department Name")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.name) = $event)),
            class: "form-control",
            type: "text",
            placeholder: "Name",
            maxlength: "32"
          }, null, 512), [
            [_vModelText, compState.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[5] || (_cache[5] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Price")
        ], -1)),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: "Threshold",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.price) = $event))
          }, null, 512), [
            [_vModelText, compState.price]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: priceDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: priceIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "preset",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.preset) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.preset]
                ]),
                _cache[6] || (_cache[6] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "preset"
                }, "Preset", -1))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[7] || (_cache[7] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Alternative Display Language")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            placeholder: "Alternative Display Language",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.altLangText) = $event)),
            maxlength: "32",
            readonly: "",
            "data-bs-toggle": "modal",
            "data-original-title": "test",
            "data-bs-target": "#alt-lang-modal"
          }, null, 512), [
            [_vModelText, compState.altLangText]
          ])
        ])
      ])
    ]),
    _createVNode(_unref(condimentsAltLangModal), { onOnSave: onEditAltLang })
  ], 64))
}
}

})